import React from 'react';
import { Helmet } from "react-helmet";
import config from '../config/app.json';

class helmet extends React.Component {
  render() {
    return (
      <Helmet
        title={this.props.title}
        titleTemplate = {`%s | ${config.title}`}
        defaultTitle = {config.title}
        meta={[
          {name: "description", content: this.props.description},
        ]}
        link={[
          {rel: "canonical", href: config.url + this.props.canonical},
        ]}
      />
    )
  }
}
helmet.defaultProps = {
  description:"",
  canonical: ""
};
export default helmet


// WEBPACK FOOTER //
// ./src/component/Helmet.js